"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAccessible;

var _calculateContrastRatio = _interopRequireDefault(require("./calculateContrastRatio"));

// enhanced ratio (AAA rating)

/**
 * WCAG 2.0 level AA requires a contrast ratio of at least 4.5:1 for normal text and 3:1 for large
 * text. WCAG 2.1 requires a contrast ratio of at least 3:1 for graphics and user interface
 * components (such as form input borders). WCAG Level AAA requires a contrast ratio of at least 7:1
 * for normal text and 4.5:1 for large text.
 *
 * Enhanced ratio for graphical objects is not defined.
 */
function isAccessible(rgbForeground, rgbBackground) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'NORMAL_TEXT';
  var successCriteria = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'AA';
  var contrast = (0, _calculateContrastRatio.default)(rgbForeground, rgbBackground);

  if (successCriteria === 'AA') {
    if (context === 'NORMAL_TEXT') {
      return contrast >= 4.5;
    } else if (context === 'LARGE_TEXT' || context === 'GRAPHICAL_OBJECTS') {
      return contrast >= 3.0;
    }

    context;
    return false;
  } else if (successCriteria === 'AAA') {
    if (context === 'NORMAL_TEXT') {
      return contrast >= 7.0;
    } else if (context === 'LARGE_TEXT') {
      return contrast >= 4.5;
    } else if (context === 'GRAPHICAL_OBJECTS') {
      // technically, this is not defined so we use the value from AA rating
      return contrast >= 3.0;
    }

    context;
    return false;
  }

  successCriteria;
  return false;
}